var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494",
    transform: "translate(-1734 -1426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_99",
    "data-name": "Rect\\xE1ngulo 99",
    width: 26,
    height: 26,
    transform: "translate(1734 1426)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "upload_file_FILL0_wght300_GRAD0_opsz40",
    d: "M186.9-848.989v4.219a.606.606,0,0,0,.181.448.612.612,0,0,0,.45.18.6.6,0,0,0,.447-.18.612.612,0,0,0,.178-.448v-4.219l1.624,1.631q.074.074.27.032t.372-.092a2.134,2.134,0,0,1,.276-.063q.1-.014-.033.119a.6.6,0,0,0,.185-.442.643.643,0,0,0-.195-.442l-2.608-2.57a.74.74,0,0,0-.259-.175.8.8,0,0,0-.289-.053.785.785,0,0,0-.287.053.748.748,0,0,0-.257.175l-2.591,2.6a.607.607,0,0,0-.188.438.639.639,0,0,0,.187.454.655.655,0,0,0,.445.18.593.593,0,0,0,.439-.187ZM181.565-841a1.506,1.506,0,0,1-1.1-.46,1.506,1.506,0,0,1-.46-1.1v-15.872a1.506,1.506,0,0,1,.46-1.1,1.506,1.506,0,0,1,1.1-.46h7.793a1.505,1.505,0,0,1,.611.127,1.7,1.7,0,0,1,.5.336l4.064,4.064a1.7,1.7,0,0,1,.336.5,1.506,1.506,0,0,1,.127.611v11.793a1.506,1.506,0,0,1-.46,1.1,1.506,1.506,0,0,1-1.1.46Zm7.812-14.195v-3.549h-7.812a.294.294,0,0,0-.212.1.294.294,0,0,0-.1.212v15.872a.294.294,0,0,0,.1.212.294.294,0,0,0,.212.1h11.872a.294.294,0,0,0,.212-.1.294.294,0,0,0,.1-.212v-11.849h-3.586a.755.755,0,0,1-.555-.227A.755.755,0,0,1,189.377-855.194Zm-8.119-3.549v0Z",
    transform: "translate(1559.998 2290)",
    fill: "#00bdd9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f9f1f7d46c0cd53468bcd997e785f281.svg";
export { ForwardRef as ReactComponent };